import {
  ChevronDownIcon,
  LockClosedIcon,
  LockOpenIcon,
  PlusIcon,
  UserGroupIcon,
} from "@heroicons/react/outline";

const RoomDetailHeader = ({ roomDtails }) => {
  return (
    <div className="lg:flex lg:justify-between lg:items-center">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <UserGroupIcon className="h-12 bg-green-600 text-white px-3 py-3 rounded-full shadow-md" />
          <h1 className="text-lg sm:text-xl font-semibold">
            {roomDtails.roomName}
          </h1>
          {roomDtails.privacyMode === "Private" ? (
            <LockClosedIcon className="h-6 text-green-400" />
          ) : (
            <LockOpenIcon className="h-6 text-green-400" />
          )}
        </div>
        <div className="lg:hidden">
          <ChevronDownIcon className="h-6 ml-2" />
        </div>
      </div>
      <div className="flex items-center space-x-3 justify-center mt-5 lg:mt-0">
        <button className="flex uppercase text-xs lg:text-sm items-center space-x-3 border-2 border-green-500 bg-white px-4 py-2 rounded-xl">
          <PlusIcon className="h-4 text-gray-500 mr-2" />
          invite people
        </button>
        <button className="flex uppercase text-xs lg:text-sm items-center space-x-3 border-2 border-green-500 bg-green-600 text-white px-4 py-2 rounded-xl">
          Shedule Meeting
          <ChevronDownIcon className="h-4 text-white ml-2" />
        </button>
      </div>
    </div>
  );
};

export default RoomDetailHeader;
